import { FormattedMessage } from 'react-intl';
import { Button } from 'semantic-ui-react';

import { expandToBackendURL } from '@plone/volto/helpers/Url/Url';

import { modifyLocation, deleteLocation } from '../../../actions';
import { MANAGER_STATUS_FLOW } from '../../../constants';

export const LocationActions = ({
  status,
  statuses,
  dispatch,
  location,
  isManager,
}) => {
  const actions = MANAGER_STATUS_FLOW?.[status] || [];
  return (
    <>
      {isManager ? (
        actions.map((action, key) => (
          <Button
            key={key}
            className={
              action.to === '2'
                ? 'primary-color'
                : action.to === '3'
                  ? 'rejected-color'
                  : 'pending-color'
            }
            onClick={() =>
              dispatch(
                modifyLocation(expandToBackendURL(location.location['@id']), {
                  status: statuses.find((s) => s.value === action.to).value,
                  user_id: location.user_id,
                }),
              )
            }
          >
            {action.title}
          </Button>
        ))
      ) : (
        <Button
          className="rejected-color"
          onClick={() =>
            dispatch(
              deleteLocation(expandToBackendURL(location.location['@id'])),
            )
          }
        >
          <FormattedMessage id="Remove" defaultMessage="Remove" />
        </Button>
      )}
    </>
  );
};
